import { ref, computed } from 'vue'

import { useJobsSdk } from '~/gql'
import type { FeatureType } from '~/gql/jobs/queries/getFeatures/types'

export const useFeatures = () => {
  const { getFeatures } = useJobsSdk()

  const features = ref<FeatureType[]>()
  const featuresLoading = ref(false)

  const fetchFeatures = async () => {
    featuresLoading.value = true

    try {
      const res = await getFeatures()
      features.value = res.data?.features ?? []
    } finally {
      featuresLoading.value = false
    }
  }

  const featuresLookup = computed(() => Object.fromEntries(features.value?.map((feature) => [feature.slug, feature.nettoPrice]) || []))

  return {
    features,
    featuresLoading,
    fetchFeatures,
    featuresLookup,
  }
}
